import { ApplicationConfig, DEFAULT_CURRENCY_CODE, isDevMode, LOCALE_ID, provideBrowserGlobalErrorListeners } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeEsCO from '@angular/common/locales/es-CO';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideServiceWorker } from '@angular/service-worker';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { errorInterceptor } from './core/interceptors/error.interceptor';
import { demoInterceptor } from './core/demo/demo.interceptor';
import { routes } from './app.routes';

/**
 * F1.16 — los datos del idioma se registran AQUÍ, en el mismo fichero que lo declara, y no en `main.ts`.
 *
 * `LOCALE_ID` sin `registerLocaleData` no es un formato feo: el `DatePipe` LANZA («NG0701: Missing locale data»).
 * Teniéndolos juntos, quien toque uno ve el otro, y cualquier prueba que use esta configuración registra los datos
 * por el propio import. Se descubrió escribiendo la prueba de las fechas, que fallaba justo así.
 */
registerLocaleData(localeEsCO, 'es-CO');

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    // F1.16: el idioma del POS es es-CO, no el del navegador ni el de Angular por defecto (en-US).
    { provide: LOCALE_ID, useValue: 'es-CO' },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'COP' },
    // Modo Ruta desplaza la página: al abrir otra pantalla se empieza arriba, y al volver se recupera donde iba.
    provideRouter(routes, withInMemoryScrolling({ scrollPositionRestoration: 'enabled' })),
    // demoInterceptor el primero: en el demo contesta aquí y nada sale. (Detrás del de autenticación tampoco saldría
    // nada, pero así se lee en orden: primero se decide si la petición sale.)
    // Después authInterceptor, que adjunta el Bearer antes de que errorInterceptor envuelva errores.
    provideHttpClient(withInterceptors([demoInterceptor, authInterceptor, errorInterceptor])),
    // F2 (Inc.4): Service Worker que cachea el shell para cargar el POS sin red.
    // Solo se registra en builds de producción/staging (no en dev).
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ]
};
